import { TemplateRef } from "@angular/core";

export type ModalSize = 'small' | 'medium' | 'large';

export interface GenericModalData {
  title?: string;
  content?: string;
  contentTemplate?: TemplateRef<any>;
  contentFooter?: string;
  footerTemplate?: TemplateRef<any>;
}
